import React, { useState, useCallback } from 'react';
import { Message } from 'semantic-ui-react';
import SlideInPanel from '../SlideInPanel';
import { BookFormEnh } from '../../bookWorksheet/components/forms';
import { useSharedData } from '../../bookWorksheet/hooks/core/useZoneHooks';
import bookStack from '../../assets/justBookStack.svg'

/**
 * AddBookPanel Component
 * Panel for creating a new book within a literary group
 */
const AddBookPanel = ({ isOpen, onClose, onSuccess, litGroup }) => {
  const sharedData = useSharedData();

  // State
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // Get actions from shared data
  const {
    setLitGroupSelection,
    setBookSelection,
    fetchBooks
  } = sharedData.actions;

  // Set literary group context when panel opens
  React.useEffect(() => {
    if (isOpen && litGroup) {
      // Set the literary group context
      setLitGroupSelection(litGroup.uuid);
      // Clear book selection to show blank form
      setBookSelection(null);
    }
  }, [isOpen, litGroup, setLitGroupSelection, setBookSelection]);

  // Handle save
  const handleSaveBook = useCallback(async (updatedBook) => {
    try {
      setIsSaving(true);

      // After successful save
      if (updatedBook && updatedBook.uuid) {
        // Set the selection to the new book
        setBookSelection(updatedBook.uuid);

        // Refresh the books list for the literary group
        if (litGroup && litGroup.uuid) {
          await fetchBooks(litGroup.uuid);
        }

        // Show success message
        setSuccessMessage('Book created successfully');

        // Call success callback if provided
        if (onSuccess) {
          onSuccess(updatedBook);
        }

        // Close panel after a short delay
        setTimeout(() => {
          onClose();
          setSuccessMessage('');
        }, 1500);
      }
    } catch (error) {
      console.error('Error creating book:', error);
      setErrorMessage('Failed to create book');
      setTimeout(() => setErrorMessage(''), 5000);
    } finally {
      setIsSaving(false);
    }
  }, [litGroup, setBookSelection, fetchBooks, onSuccess, onClose]);

  // Handle panel close
  const handleClose = () => {
    if (!isSaving) {
      setSuccessMessage('');
      setErrorMessage('');
      onClose();
    }
  };

  const panelTitle = litGroup
    ? `Add Book to ${litGroup.name}`
    : 'Add Book';

  return (
    <SlideInPanel
      isOpen={isOpen}
      onClose={handleClose}
      title={panelTitle}
      width="700px"
      headerImg={bookStack}
    >
      {!litGroup ? (
        <Message warning>
          <Message.Header>No Literary Group Selected</Message.Header>
          <p>Please select a literary group before adding a book.</p>
        </Message>
      ) : (
        <>
          {successMessage && (
            <Message positive>
              <Message.Header>Success</Message.Header>
              <p>{successMessage}</p>
            </Message>
          )}

          {errorMessage && (
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{errorMessage}</p>
            </Message>
          )}

          <div style={{ padding: '1rem 0' }}>
            {/* <Message info size="small">
              <Message.Header>Creating book in:</Message.Header>
              <p>{litGroup.name}</p>
            </Message> */}

            <BookFormEnh
              onSave={handleSaveBook}
              isPanel={true}
            />
          </div>
        </>
      )}
    </SlideInPanel>
  );
};

export default AddBookPanel;
